import { API } from "./utils"

export const notifications = {
  notificationsList: (params=null) => API.get("/notifications/notifications/", { params }),
  markRead: (id) => API.post(`/notifications/notifications/${id}/mark-read/`),
  markAllRead: () => API.post("/notifications/notifications/mark-all-read/"),
}
